import {UISTATES, KEYCODES} from '../enum';

function getPreviousIndexes(results, destinationIndex) {
    if (destinationIndex > 0) {
        const previousDestinationIndex = destinationIndex - 1;
        const previousResult = results[previousDestinationIndex];
        const prevDestinationSubDestinations = previousResult.subSuggestions;
        if (prevDestinationSubDestinations && !previousResult.recentlyviewed) {
            return {
                selectDestinationIndex: previousDestinationIndex,
                selectDestinationSubIndex:
                    prevDestinationSubDestinations.length - 1
            };
        }
        return {
            selectDestinationIndex: previousDestinationIndex,
            selectDestinationSubIndex: -1
        };
    }

    const lastDestinationIndex = results.length - 1;
    const lastDestinationSubDestinations =
        results[lastDestinationIndex].subSuggestions;
    if (lastDestinationSubDestinations) {
        return {
            selectDestinationIndex: lastDestinationIndex,
            selectDestinationSubIndex: lastDestinationSubDestinations.length - 1
        };
    }
    return {
        selectDestinationIndex: lastDestinationIndex,
        selectDestinationSubIndex: -1
    };
}

function getNextIndexes(results, destinationIndex) {
    if (destinationIndex < results.length - 1) {
        return {
            selectDestinationIndex: destinationIndex + 1,
            selectDestinationSubIndex: -1
        };
    }
    return {
        selectDestinationIndex: 0,
        selectDestinationSubIndex: -1
    };
}

/**
 * keypress()
 * Process keypress event
 * @param {*} state
 * @param {*} ev
 */
export function keypress(state = {}, ev = {}) {
    const {
        uistate,
        selectDestinationIndex,
        selectDestinationSubIndex,
        results
    } = state;
    const {keyCode} = ev;

    // 'escape'
    if (keyCode === KEYCODES.ESCAPE) {
        return {uistate: UISTATES.CLOSED};
    }

    // 'tab'
    if (
        keyCode === KEYCODES.TAB &&
        ev.target.className.indexOf('search-destination-input__close') !== -1
    ) {
        if (uistate === UISTATES.SELECT_DESTINATION) {
            return true;
        }
    }

    // 'enter' or 'tab' from clear results
    if (keyCode === KEYCODES.ENTER) {
        ev.preventDefault();
        ev.stopPropagation();
        if (uistate === UISTATES.SELECT_DESTINATION) {
            return true;
        }
    }

    // 'up'
    if (keyCode === KEYCODES.UP) {
        ev.preventDefault();
        ev.stopPropagation();
        if (uistate === UISTATES.SELECT_DESTINATION) {
            if (selectDestinationSubIndex >= 0) {
                return {
                    selectDestinationSubIndex: selectDestinationSubIndex - 1
                };
            }
            return getPreviousIndexes(results, selectDestinationIndex);
        }
    }

    // 'down'
    if (keyCode === KEYCODES.DOWN) {
        ev.preventDefault();
        ev.stopPropagation();
        if (uistate === UISTATES.CLOSED) {
            return {uistate: UISTATES.SELECT_DESTINATION};
        }
        if (uistate === UISTATES.SELECT_DESTINATION) {
            if (selectDestinationIndex === -1) {
                return {
                    selectDestinationIndex: 0
                };
            }
            const currentResult = results[selectDestinationIndex];
            const currentSubDestinations = currentResult.subSuggestions;
            if (
                !currentResult.recentlyviewed &&
                currentSubDestinations &&
                currentSubDestinations.length - 1 > selectDestinationSubIndex
            ) {
                return {
                    selectDestinationSubIndex: selectDestinationSubIndex + 1
                };
            }
            return getNextIndexes(results, selectDestinationIndex);
        }
    }

    // 'right'
    if (keyCode === KEYCODES.RIGHT) {
        if (uistate === UISTATES.SELECT_DESTINATION) {
            if (
                ev.target &&
                ev.target.value &&
                ev.target.value.length === ev.target.selectionStart
            ) {
                return true;
            }
        }
    }

    return false;
}
